export default __webpack_public_path__ + "static/media/ellipsis-menu-icon.2cda8e67.svg";